module.exports = __webpack_public_path__ + "assets/img/INTERIOR5.7d2d7351.png";